import { render, staticRenderFns } from "./PagePrev.vue?vue&type=template&id=11e1ebb1&"
import script from "./PagePrev.vue?vue&type=script&lang=js&"
export * from "./PagePrev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports